import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider, closeSnackbar } from 'notistack';

import "./tailwind.css"
import "./App.css"
import './i18n'; // Importar configuración de i18n
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
  <SnackbarProvider 
    maxSnack={3}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    dense
    preventDuplicate
    autoHideDuration={4000}
    action={(snackbarId) => (
      <button
        onClick={() => closeSnackbar(snackbarId)}
        className="text-white hover:text-gray-200 ml-2"
        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
      >
        ✕
      </button>
    )}
  >
      <App />
  </SnackbarProvider>
  </BrowserRouter>
);